<template>
<b-container style="max-width: 1200px !important">
<b-row class="justify-content-center align-items-center">
    <h5 style="text-align:center" >QUANTEEC x Video.js</h5>   
</b-row>

<b-tabs>
  <b-tab :title="$ml.get('plugininstallfromCDN')">
    <b-row class="justify-content-center align-items-center marginaltopsm">
        <p style="margin-bottom:0px" v-html="$ml.get('pluginp1')">
                
        </p>
    </b-row>

    <b-row class="justify-content-center align-items-center">
    <ol class="center" style="margin: 10px">
        <li style="margin-bottom:10px">
            {{$ml.get('pluginp8')}}<br />
            <code>
                {{line1_vjs}}
            </code>
            <font-awesome-icon class="pointerEltSB" style="font-size:10px; color:#2a5d77" icon="clone" @click="$refs.copied.copyToClipboard(line1_vjs)" />
        </li>
        <li style="margin-bottom:10px">
            {{$ml.get('pluginp11')}}<br /> 
            <code>{{configLine}}
            </code>
            <font-awesome-icon class="pointerEltSB" style="font-size:10px; color:#2a5d77" icon="clone" @click="$refs.copied.copyToClipboard(line2_vjs)" />
        </li>
        <li style="margin-bottom:10px">
            {{$ml.get('pluginp12')}}<br />
            <code>
                {{line3_vjs}}
            </code>
            <font-awesome-icon class="pointerEltSB" style="font-size:10px; color:#2a5d77" icon="clone" @click="$refs.copied.copyToClipboard(line3_vjs)" />
        </li>
            <li style="margin-bottom:10px">
            {{$ml.get('pluginp13')}}<br />
            <code>
                {{line4_vjs}}
            </code>
            <font-awesome-icon class="pointerEltSB" style="font-size:10px; color:#2a5d77" icon="clone" @click="$refs.copied.copyToClipboard(line4_vjs)" />
        </li>
    </ol>
    </b-row>

    <b-row>
    <b-col cols="12">
        <b-row class="justify-content-center marginalbotsm">
            <b-col cols="auto">
                <b-button @click="activePlugin = 'noDRM'" :variant="(activePlugin === 'noDRM') ? 'greenw':'msstreamblue'">{{$ml.get('examplenodrm')}}</b-button>
                &nbsp;
                <b-button @click="activePlugin = 'withDRM'" :variant="(activePlugin !== 'noDRM') ? 'greenw':'msstreamblue'" >{{$ml.get('exampledrm')}}</b-button>
            </b-col>
        </b-row>
        <b-row class="mt-2">

            <div class="col-xl-7 col-12" v-if="activePlugin === 'noDRM'" v-html="$ml.get('vjs_example')" ></div>
            <div class="col-xl-7 col-12" v-if="activePlugin === 'withDRM'" v-html="$ml.get('vjs_examplewDRM')"></div>   

        <vue-markdown :show="activePlugin === 'noDRM'" style="overflow: auto;" class="col-xl-7 col-12" :style="(activePlugin === 'withDRM')?'display: none' : ''" @rendered="onrender">
``` html
    &lt;head>
        &lt;link href="https://vjs.zencdn.net/7.18.1/video-js.css" rel="stylesheet" />

        &lt;script src="https://vjs.zencdn.net/7.18.1/video.min.js">&lt;/script>
        &lt;script src="https://files.quanteec.com/quanteec/latest/videojs-quanteec-plugin.js">&lt;/script> &lt;!-- 1-include QUANTEEC script-->
    &lt;/head>
    &lt;body>
        &lt;video id="videoplayer" class="video-js vjs-default-skin" controls>&lt;/video>

        &lt;script>
            document.addEventListener("DOMContentLoaded", function () {
                var videoSource = "https://my.server.com/videoSource.m3u8";
                
                // 2-Adjust QUANTEEC configuration
                var configQuanteec = {
                    quanteecKey: "{{ streamKey }}",
                    videoID: "customVideoID" // [Optional but recommended] String --> specific name to identify a video. Useful if the videosource url contains a token which is different for every users. Default: the videoSource value is used.
                };
                
                // 3-Link QUANTEEC configuration to videojs object *before* the creation of the videojs player instance
                var vjsObject = {
                    html5: { 
                        quanteec: configQuanteec
                    }
                }

                // 4-Register the Quanteec plugin in videojs
                quanteecSourceHandler.register();

                var player = videojs('videoplayer', vjsObject);

                player.src([
                    {
                        src: videoSource,
                        type: 'application/x-mpegurl'
                    }
                ])     


                player.ready(function () {
                    player.play();
                })
                
            });
        &lt;/script>
    &lt;body>
    ```
        </vue-markdown>    
        
        <vue-markdown :show="activePlugin === 'withDRM'" style="overflow: auto;" class="col-7" :style="(activePlugin === 'noDRM')?'display: none' : ''" @rendered="onrender">
``` html
    &lt;head>
        &lt;link href="https://vjs.zencdn.net/7.18.1/video-js.css" rel="stylesheet" />

        &lt;script src="https://vjs.zencdn.net/7.18.1/video.min.js">&lt;/script>
        &lt;script src="./videojs-contrib-eme.min.js">&lt;/script> &lt;!-- script for DRMs-->
        &lt;script src="https://files.quanteec.com/quanteec/latest/videojs-quanteec-plugin.js">&lt;/script> &lt;!-- 1-include QUANTEEC script-->
    &lt;/head>
    &lt;body>
        &lt;video id="videoplayer" class="video-js vjs-default-skin" controls>&lt;/video>

        &lt;script>
            document.addEventListener("DOMContentLoaded", function () {
                var videoSource = "https://my.server.com/videoSource.m3u8";
                
                // 2-Adjust QUANTEEC configuration
                var configQuanteec = {
                    quanteecKey: "{{ streamKey }}",
                    videoID: "customVideoID" // [Optional but recommended] String --> specific name to identify a video. Useful if the videosource url contains a token which is different for every users. Default: the videoSource value is used.
                };
                
                // 3-Link QUANTEEC configuration to videojs object *before* the creation of the videojs player instance
                var vjsObject = {
                    html5: { 
                        quanteec: configQuanteec
                    }
                }

                // 4-Register the Quanteec plugin in videojs
                quanteecSourceHandler.register();

                var player = videojs('videoplayer', vjsObject);

                player.src([
                    {
                        src: videoSource,
                        type: 'application/x-mpegurl',
                        // DRM part
                        keySystems: {                                
                            "com.widevine.alpha": {
                                url : "URL_TO_LICENSE_SERVER",
                                audioContentType: 'AUDIO_CONTENT_TYPE',
                                videoContentType: 'VIDEO_CONTENT_TYPE',
                            },
                            "com.microsoft.playready": {
                                url : "URL_TO_LICENSE_SERVER",
                                audioContentType: 'AUDIO_CONTENT_TYPE',
                                videoContentType: 'VIDEO_CONTENT_TYPE',
                            },
                            "com.apple.fps.1_0": {
                                certificateUri: 'CERTIFICATE_URL',
                                licenseUri: 'LICENSE_URL'
                            },
                        // End DRM part    
                    }
                ])     


                player.ready(function () {
                    player.play();
                })
                
            });
        &lt;/script>
    &lt;body>
    ```
        </vue-markdown>

        <ConfigDoc class="col-xl-5 col-12">
        </ConfigDoc>
    
    </b-row>
    </b-col>
    </b-row>
  </b-tab>
    <b-tab :title="$ml.get('plugininstallfromNPM')">

    <b-row class="justify-content-center align-items-center marginaltopsm">
      <p style="margin-bottom:0px" v-html="$ml.get('pluginp1npm')">
                
      </p>
    </b-row>

    <b-row class="justify-content-center align-items-center">
      <ol class="center" style="margin: 10px">
              <li style="margin-bottom:10px">
                  {{$ml.get('pluginloginnpm')}}<br />
                  <code>
                    {{$ml.get('loginnpmcode')}}
                  </code>
                  <font-awesome-icon class="pointerEltSB" style="font-size:10px; color:#2a5d77" icon="clone" @click="$refs.copied.copyToClipboard($ml.get('loginnpmcode'))" />
              </li>             
              <li style="margin-bottom:10px">
                  {{$ml.get('plugininstallnpm')}}<br />
                  <code>
                    {{$ml.get('installnpmpackage')}}
                  </code>
                  <font-awesome-icon class="pointerEltSB" style="font-size:10px; color:#2a5d77" icon="clone" @click="$refs.copied.copyToClipboard($ml.get('installnpmpackage'))" />
              </li>              
              <li style="margin-bottom:10px">
                  {{$ml.get('pluginimportnpm')}}<br />
                  <code>
                    {{$ml.get('pluginimporthvideoJSsnpm')}}
                  </code>
                  <font-awesome-icon class="pointerEltSB" style="font-size:10px; color:#2a5d77" icon="clone" @click="$refs.copied.copyToClipboard($ml.get('pluginimporthvideoJSsnpm'))" />
              </li>
                      <li style="margin-bottom:10px">
            {{$ml.get('pluginp11')}}<br /> 
            <code>{{configLine}}
            </code>
            <font-awesome-icon class="pointerEltSB" style="font-size:10px; color:#2a5d77" icon="clone" @click="$refs.copied.copyToClipboard(line2_vjs)" />
        </li>
            <li style="margin-bottom:10px">
                {{$ml.get('pluginp12')}}<br />
                <code>
                    {{line3_vjs}}
                </code>
                <font-awesome-icon class="pointerEltSB" style="font-size:10px; color:#2a5d77" icon="clone" @click="$refs.copied.copyToClipboard(line3_vjs)" />
            </li>
                <li style="margin-bottom:10px">
                {{$ml.get('pluginp13')}}<br />
                <code>
                    {{line4_vjs}}
                </code>
                <font-awesome-icon class="pointerEltSB" style="font-size:10px; color:#2a5d77" icon="clone" @click="$refs.copied.copyToClipboard(line4_vjs)" />
            </li>
      </ol>
    </b-row>

    <b-row class="mt-2">
      <ConfigDoc class="col-12">
      </ConfigDoc>
    </b-row>
  </b-tab>
</b-tabs>

<CopiedModal ref="copied"/>

</b-container>

</template>
<script>
import ConfigDoc from '@/components/documentation/plugins/ConfigDoc.vue';
import VueMarkdown from 'vue-markdown';
import CopiedModal from '@/components/modals/CopiedModal.vue';
import Prism from 'prismjs';
import 'prismjs/themes/prism-twilight.css';
export default {
  name: 'Videojs',
  data: function() {
    return {
        activePlugin:"noDRM",
        line1_vjs: '<script src="https://files.quanteec.com/quanteec/latest/videojs-quanteec-plugin.js"><'+'/script>',
        line3_vjs: 'var vjsObject = { html5: { quanteec: configQuanteec } }',
        line4_vjs: 'quanteecSourceHandler.register();',
    }
  },
  props: [
      "streamKey",
      "configLine"

  ],
  components: {
      VueMarkdown,
      ConfigDoc,
      CopiedModal
  },
  mounted: function() {

    this.$nextTick(() => {
        Prism.highlightAll()
      });  
  },
  methods: {
     onrender() {
        this.$nextTick(() => {
        Prism.highlightAll()
      });  
     }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

.center {
    display: table;
    margin-left: auto;
    margin-right: auto;
    list-style-position: inside;
}

</style>